<template>
  <sf-alert-base :icon="mdiAlertOctagonOutline" type="error">
    <slot />
  </sf-alert-base>
</template>

<script setup lang="ts">
import SfAlertBase from '@/components/alerts/SfAlertBase.vue'

import { mdiAlertOctagonOutline } from '@mdi/js'
</script>
